export enum UploadType {
  CompanyLogos = 'CompanyLogos',
  FirmLogos = 'FirmLogos',
  UserImages = 'UserImages',
  FundDocuments = 'FundDocuments',
  ReportingAttachments = 'ReportingAttachments',
  WithdrawalAttachments = 'WithdrawalAttachments',
  InvestorIdvCertificates = 'InvestorIdvCertificates',
  EisCertificates = 'EisCertificates',
  PdfUpdates = 'PdfUpdates',
  KycDocuments = 'KycDocuments',
  FirmDocuments = 'FirmDocuments',
  PdfExitStatement = 'PdfExitStatement',
  CustomUpdateAttachments = 'CustomUpdateAttachments',
  BackgroundExports = 'BackgroundExports',
  LpTransactionAttachments = 'LpTransactionAttachments',
  LpBankStatements = 'LpBankStatements',
  InterestPayments = 'InterestPayments',
  InterestPaymentsWriteOutput = 'InterestPaymentsWriteOutput',
  DeploymentUpdateAttachments = 'DeploymentUpdateAttachments',
  DataRoomDocuments = 'DataRoomDocuments',
  InvestorClassificationDocuments = 'InvestorClassificationDocuments',
  VehicleSigningDocuments = 'VehicleSigningDocuments',
  OnboardingCustomRequestDocuments = 'OnboardingCustomRequestDocuments',
  InvestorTaxDocuments = 'InvestorTaxDocuments',
  CommitmentDocuments = 'CommitmentDocuments',
}
